import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatPrice } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && !user) nav("/login");
    if (user) api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {});
  }, [user, loading]);

  if (loading || !user) return <div className="py-24 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-12">
      <div className="flex items-center justify-between mb-10">
        <div><p className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">My Account</p><h1 className="font-display text-4xl mt-1">Hello, {user.name}</h1></div>
        <div className="flex gap-2">
          {user.role === "admin" && <Link to="/admin"><Button variant="outline" className="rounded-none border-black dark:border-white">Admin</Button></Link>}
          <Button onClick={() => { logout(); nav("/"); }} variant="outline" className="rounded-none border-border" data-testid="logout-btn">Sign Out</Button>
        </div>
      </div>
      <h2 className="font-display text-2xl mb-5">Order History</h2>
      {orders.length === 0 ? (
        <div className="bg-[#F5F1E8] dark:bg-[#141414] p-10 text-center text-muted-foreground"><p>No orders yet.</p><Link to="/shop"><Button className="mt-4 rounded-none bg-[#D4AF37] text-black">Shop Now</Button></Link></div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.order_id} className="border border-border p-5 flex flex-wrap items-center justify-between gap-3" data-testid={`order-${o.tracking_number}`}>
              <div><p className="font-display text-lg">{o.tracking_number}</p><p className="text-sm text-muted-foreground">{new Date(o.created_at).toLocaleDateString()} · {o.items?.length} items</p></div>
              <span className={`text-xs uppercase tracking-wide px-3 py-1 ${o.payment_status === "paid" ? "bg-[#D4AF37] text-black" : "bg-secondary"}`}>{o.status}</span>
              <span className="font-medium">{formatPrice(o.total)}</span>
              <Link to={`/track-order?t=${o.tracking_number}`} className="text-sm text-[#D4AF37] underline">Track</Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
